import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from "@hooks";
import { useEffect } from "react";

import DropdownSelect, {
  DropdownOption,
} from "../../common/dropdown/DropdownSelect";

const SelectTeam = ({
  currentTeam,
  setCurrentTeam,
  showLabel = true,
  propHandleChange,
}) => {
  const { userTeams } = useAuth();

  useEffect(() => {
    if (!currentTeam?.uuid && userTeams?.length) {
      setCurrentTeam(userTeams[0]);
    }
  }, [currentTeam, userTeams]);

  if (!userTeams?.length || userTeams.length <= 1) {
    return null;
  }

  const handleChange = async (_, value) => {
    const team = userTeams?.find((team) => team?.uuid === value);
    setCurrentTeam(team);
  };

  const handleSelectChange = propHandleChange || handleChange;

  return (
    <div className="flex flex-row items-center dark:bg-gray-700 bg-gray-100 pl-3 rounded-xl text-indigo-500 relative">
      {showLabel && (
        <label
          className={`absolute -top-4 left-0 text-xs pl-1 dark:text-gray-300 text-black`}
        >
          Select Team
        </label>
      )}

      <div className="flex items-center flex-1">
        <FontAwesomeIcon icon={faUsers} />
        <DropdownSelect
          value={currentTeam?.uuid || userTeams[0]?.uuid}
          onChange={handleSelectChange}
          width="w-full min-w-48"
        >
          {userTeams?.map((team) => (
            <DropdownOption key={team.uuid} value={team.uuid}>
              {team.name}
            </DropdownOption>
          ))}
        </DropdownSelect>
      </div>
    </div>
  );
};

export default SelectTeam;
